const Elements = () => {
    return(
      <>
        {/* Scroll Top */}
        <a href="#" id="scroll-top" className="scroll-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short" /></a>
        {/* Preloader */}
        <div id="preloader">
          <div />
          <div />
          <div />
          <div />
        </div>
      </>
    )
}
export default Elements